/*!
 * IKAI Monthly Ration \u2014 theme asset (assets/ikai-ration.js)
 * The page content (products, family boxes, texts, regions, reviews, FAQs, tiers)
 * comes from the "IKAI Monthly Ration" section settings in the theme editor.
 * This file only draws the builder and makes it interactive.
 */
(function () {
  "use strict";
  var REV = {"healthy-indian-breakfast-organic-lokwan-wheat-dalia500g-organic-poha-red-500g":[2,5],"ikai-natural-lakadong-turmeric-8-curcumin-content-regional-specialty-meghalaya-100g":[6,4.83],"natural-a2-gir-cow-ghee-vedic-bilona-method-curd-churned-250g":[4,5],"natural-asafoetida-hing-granular-extra-strong-aromatic-spice-50g":[5,4.6],"natural-assam-black-rice-purple-when-cooked-regional-specialty-assam-500g":[4,4.75],"natural-bhut-jolokia-king-chilli-regional-speciality-nagaland-ghost-pepper-25g":[3,4.67],"natural-bird-s-eye-chilli-mizo-hmarchate-regional-speciality-mizoram-exotic-25g":[2,4],"natural-black-pepper-powder-sohmrit-khri-regional-speciality-meghalaya-100g":[2,5],"natural-black-pepper-whole-kali-mirch-sohmrit-regional-speciality-meghalaya-100g":[2,4.5],"natural-black-salt-kala-namak-mineral-rich-flavour-enhancer-100g":[3,4.33],"natural-desiccated-coconut-high-fibre-healthy-fats-unsweetened-250g":[3,4.67],"natural-dry-white-peas-natural-protein-foods-gluten-free-indian-foods-500g":[3,4.67],"natural-himalayan-pink-salt-sendha-namak-pink-colour-non-iodised-1000g":[4,4.75],"natural-joha-rice-heirloom-rice-aromatic-regional-specialty-assam-1000g":[15,4.93],"natural-kashmir-wild-flower-honey-unprocessed-regional-specialty-kashmir-350g":[2,4],"natural-khasi-sticky-rice-gelatinous-regional-specialty-meghalaya-500g":[3,5],"natural-kokum-dried-mangosteen-regional-speciality-maharashtra-exotic-75g":[2,4.5],"natural-lakadong-turmeric-latte-haldi-doodh-customised-for-vitality-immunity-booster-100g":[5,4.6],"natural-mango-powder-amchur-khatai-healthy-aromatic-spice-50g":[3,4.67],"natural-meghalaya-cinnamon-dalchini-regional-speciality-meghalaya-50g":[5,4.8],"natural-nigella-seeds-kala-jeera-kalonji-mangrail-aromatic-spice-50g":[2,4],"natural-papad-natural-protein-foods-customised-for-vitality-gluten-free-250g":[4,5],"natural-poppy-seeds-khus-khus-posto-dana-pure-exotic-spice-50g":[3,4.67],"natural-raw-honey-unprocessed-filtered-healthy-sweetener-350g":[2,4.5],"natural-seedless-tamarind-imli-sour-spice-pure-100g":[2,4.5],"natural-stone-flower-dagad-phool-regional-speciality-maharashtra-exotic-25g":[1,5],"natural-tej-pata-bay-leaf-pure-sundried-aromatic-spice-25g":[2,4.5],"natural-thekra-tenga-regional-speciality-assam-exotic-spice-sour-100g":[3,4.67],"natural-whole-garam-masala-spice-mix-medicinal-pure-aromatic-50g":[3,4.67],"organic-amaranth-puff-roasted-ramdana-rajgira-customised-for-vitality-fast-friendly-150g":[10,4.9],"organic-ambemore-rice-mango-blossom-aroma-regional-specialty-maharashtra-1000g":[6,5],"organic-arhar-tuvar-dal-pigeon-pea-gluten-free-indian-food-500g":[2,4.5],"organic-basmati-rice-long-grain-aromatic-regional-specialty-kashmir-1000g":[3,4.33],"organic-besan-gram-flour-gluten-free-natural-protein-foods-450g":[2,4.5],"organic-black-mustard-seeds-kali-sarson-pure-pungent-150g":[2,4],"organic-black-sesame-seeds-kala-til-healthy-seeds-good-fats-100g":[2,5],"organic-brown-sugar-unrefined-cane-sugar-healthy-and-organic-foods-500g":[2,4.5],"organic-buckwheat-groats-kuttu-gluten-free-ancient-grain-fasting-special-500g":[2,4.5],"organic-carom-seeds-ajwain-bishop-s-weed-aromatic-spice-50g":[2,4.5],"organic-chana-dal-split-bengal-gram-gluten-free-indian-food-500g":[3,4.67],"organic-chat-masala-chatpata-spice-mix-premium-spice-blend-pure-50g":[2,4],"organic-cold-pressed-coconut-oil-wood-pressed-cooking-oil-250ml":[2,4.5],"organic-coriander-powder-dhaniya-powder-pure-aromatic-spice-100g":[2,4],"organic-coriander-seeds-sabut-dhaniya-pure-healthy-aromatic-50g":[2,5],"organic-cumin-powder-jeera-powder-pure-aromatic-spice-100g":[2,4.5],"organic-cumin-seeds-sabut-jeera-pure-healthy-aromatic-100g":[2,4.5],"organic-desi-black-chana-bengal-gram-natural-protein-foods-500g":[3,4.67],"organic-desi-cow-ghee-100-cow-ghee-healthy-organic-food-pure-250g":[9,4.78],"organic-desi-protein-drink-made-from-black-chana-sattu-natural-protein-food-customised-for-vitality-gluten-free-250g":[2,5],"organic-fennel-seeds-saunf-mouth-freshener-aromatic-spice-100g":[2,4],"organic-fenugreek-seeds-methi-seeds-pure-spice-90g":[2,5],"organic-finger-millet-ragi-atta-gluten-free-ancient-grain-nachni-450g":[4,4.75],"organic-flax-seeds-alsi-seed-roasted-healthy-seeds-good-fats-100g":[3,5],"natural-garam-masala-powder-blended-spices-100-gm":[3,4.67],"organic-ginger-powder-saunth-pure-organic-spice-50g":[2,4.5],"organic-gluten-free-atta-naturally-gluten-free-flour-mix-customised-for-vitality-500g":[3,4.67],"organic-groundnut-oil-cold-pressed-wood-pressed-unrefined-1000ml":[2,4.5],"organic-groundnut-oil-cold-pressed-wood-pressed-unrefined-500ml":[3,4.67],"organic-jaggery-cubes-gur-mineral-rich-healthy-and-organic-foods-500g":[6,4.33],"organic-jaggery-powder-gur-mineral-rich-healthy-and-organic-foods-500g":[3,4.67],"organic-jammu-rajma-regional-specialty-jammu-natural-protein-foods-500g":[4,4.5],"organic-jowar-puff-roasted-customised-for-vitality-healthy-snack-170g":[4,5],"organic-jumbo-oats-healthy-breakfast-no-preservative-gluten-free-500g":[7,4.71],"organic-kabuli-chana-white-chickpea-natural-protein-foods-500g":[4,5],"organic-kasuri-methi-sundried-organic-fenugreek-leaves-unique-flavour-10g":[2,4],"organic-khapli-atta-emmer-wheat-flour-regional-speciality-maharashtra-900g":[2,4.5],"organic-lokwan-atta-wholewheat-flour-regional-speciality-madhya-pradesh-900g":[2,4.5],"organic-lokwan-wheat-dalia-porridge-regional-specialty-madhya-pradesh-500g":[2,5],"organic-maida-all-purpose-flour-bakery-flour-refined-wheat-flour-450g":[2,4],"organic-maize-makai-atta-traditional-corn-flour-gluten-free-450g":[4,4.5],"organic-masoor-dal-red-lentil-gluten-free-organic-pulses-500g":[2,4],"organic-matta-red-rice-parboiled-plump-regional-specialty-kerala-500g":[3,4.67],"organic-mix-millet-dalia-multi-millets-customised-for-vitality-gluten-free-500g":[9,4.78],"organic-mustard-oil-sarson-ka-tel-cold-pressed-wood-pressed-1000ml":[2,4],"organic-mustard-oil-sarson-ka-tel-cold-pressed-wood-pressed-500ml":[3,5],"organic-panchratna-dal-organic-mixed-pulses-natural-protein-foods-500g":[2,5],"organic-peanuts-groundnut-healthy-fats-natural-protein-foods-500g":[4,4.25],"organic-pearl-millet-bajra-atta-gluten-free-ancient-grain-millets-450g":[2,4],"organic-poha-chivda-chuda-flattened-rice-gluten-free-500g":[5,4.6],"organic-quinoa-gluten-free-superfood-fasting-special-500g":[3,4.67],"organic-raw-sugar-desi-khandsari-healthy-and-organic-foods-1000g":[3,4.33],"organic-red-chilli-powder-lal-mirch-powder-pure-red-colour-hot-100g":[2,4.5],"organic-poha-red-chivda-chuda-flattened-red-rice-gluten-free-500g":[3,4.67],"organic-rice-flour-chawal-ka-atta-gluten-free-healthy-and-organic-foods-450g":[4,4.5],"organic-roasted-maize-dalia-customised-for-vitality-healthy-breakfast-gluten-free-500g":[4,4.5],"organic-roasted-seed-mix-customised-for-vitality-healthy-snack-100g":[4,5],"organic-sattu-regional-specialty-bihar-gluten-free-natural-protein-foods-450g":[9,5],"organic-sesame-oil-cold-pressed-wood-pressed-gingelly-oil-500ml":[2,4.5],"organic-sorghum-jowar-atta-gluten-free-ancient-grain-millets-450g":[2,4.5],"organic-sprouted-bajra-atta-bajra-atta-gluten-free-sprouted-customised-for-vitality-500g":[5,5],"organic-sprouted-finger-millet-ragi-atta-gluten-free-sprouted-customised-for-vitality-450g":[8,5],"organic-sprouted-jowar-atta-jowar-atta-gluten-free-sprouted-customised-for-vitality-500g":[3,5],"organic-sprouted-khapli-atta-ancient-emmer-wheat-sprouted-customised-for-vitality-900g":[3,5],"organic-sprouted-makkai-atta-makkai-atta-gluten-free-sprouted-customised-for-vitality-500g":[1,5],"organic-suji-rava-semolina-high-fibre-healthy-and-organic-foods-450g":[2,4.5],"organic-sunflower-oil-cold-pressed-wood-pressed-unrefined-1000ml":[2,4.5],"organic-sunflower-oil-cold-pressed-wood-pressed-unrefined-500ml":[2,5],"organic-sweet-basil-seeds-sabja-customised-for-vitality-high-protein-100g":[2,4],"organic-turmeric-powder-haldi-powder-medicinal-high-curcumin-100g":[2,5],"organic-virgin-olive-oil-cold-pressed-wood-pressed-unrefined-500ml":[2,5],"organic-white-sesame-seeds-safed-til-healthy-seeds-good-fats-100g":[2,4],"organic-whole-masoor-unpolished-red-lentil-gluten-free-indian-foods-500g":[2,4],"organic-whole-moong-green-gram-gluten-free-natural-protein-foods-500g":[2,4.5],"organic-whole-red-chilli-sabut-lal-mirch-sundried-red-colour-hot-50g":[2,4],"organic-yellow-moong-dal-yellow-gram-gluten-free-organic-pulses-500g":[1,4],"organic-yellow-mustard-seeds-peeli-sarson-vibrant-color-pungent-50g":[3,5]};
  var ORIG = ["Assam","Meghalaya","Nagaland","Mizoram","Manipur","Maharashtra","Kashmir","Jammu","Kerala","Gujarat","Bihar","Madhya Pradesh","Himalaya"];
  var CATDEF = [{"k":"rice","n":"Rice","abbr":"RI","tile":"#F0EAD6","ink":"#8A7433"},{"k":"atta","n":"Atta","abbr":"AT","tile":"#F7E7D0","ink":"#A9762F"},{"k":"millets","n":"Millets","abbr":"MI","tile":"#EEE6CF","ink":"#7E6A2C"},{"k":"dals","n":"Dals","abbr":"DA","tile":"#FBE3CB","ink":"#B4661C"},{"k":"oils","n":"Oils","abbr":"OI","tile":"#FBF0C4","ink":"#8E7310"},{"k":"ghee","n":"Ghee","abbr":"GH","tile":"#FDE9B4","ink":"#9C740A"},{"k":"spices","n":"Masalas","abbr":"MA","tile":"#FAD9C6","ink":"#B0472A"},{"k":"sweet","n":"Salt & Gur","abbr":"SG","tile":"#E6EED4","ink":"#657C31"},{"k":"breakfast","n":"Breakfast","abbr":"BR","tile":"#F3E8D8","ink":"#8C5A2B"},{"k":"seeds","n":"Seeds & Snacks","abbr":"SS","tile":"#E8EDDC","ink":"#55702F"}];

  var CATS = [],
    CORE = [],
    TIERS = [],
    EXCLUDE = [],
    REGIONS = [],
    EDU = [],
    REVIEWS = [],
    FAQS = [],
    KIRANA = [],
    IKAICOL = [],
    TRUST = [],
    BOXES = [],
    CICONS = {},
    TXT = {},
    HERO = {};
  function lines(s) {
    return String(s || "")
      .split(/\r?\n/)
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);
  }
  function FS() {
    return TIERS.length ? TIERS[0].min : 0;
  }
  function TOP() {
    return TIERS.length ? TIERS[TIERS.length - 1].min : 1;
  }
  function grp0(n) {
    var s = String(Math.round(Math.abs(n)));
    return (
      s.length > 3 &&
        (s =
          s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
          "," +
          s.slice(-3)),
      s
    );
  }
  function setup(cfg) {
    cfg = cfg || {};
    TXT = cfg.text || {};
    HERO = cfg.hero || {};
    HERO.benefits = lines(HERO.benefits).slice(0, 4);
    var bp = String(HERO.badge || "").split("|").map(function (x) {
      return x.trim();
    });
    HERO.badge_top = bp.length > 1 ? bp[0] : "";
    HERO.badge_big = bp.length > 1 ? bp[1] : bp[0] || "";
    HERO.badge_bottom = bp[2] || "";
    /* categories */
    var tiles = {};
    CATDEF.forEach(function (c) {
      tiles[c.k] = c;
    });
    CICONS = {};
    if (cfg.icons) {
      cfg.icons.all && (CICONS.all = cfg.icons.all);
      cfg.icons.popular && (CICONS.popular = cfg.icons.popular);
    }
    CATS = (cfg.categories || []).map(function (c) {
      var d = tiles[c.k] || {};
      c.icon && (CICONS[c.k] = c.icon);
      return {
        k: c.k,
        n: c.n || d.n || c.k,
        abbr: (c.n || c.k).slice(0, 2).toUpperCase(),
        tile: d.tile || "#EEF2EA",
        ink: d.ink || "#2C7A3E",
        core: !!c.core,
      };
    });
    CORE = CATS.filter(function (c) {
      return c.core;
    }).map(function (c) {
      return c.k;
    });
    /* reward tiers (rupees in settings -> paise here) */
    TIERS = lines(cfg.tiers)
      .map(function (l) {
        var m = l.replace(/[\u20B9,\s]/g, "").match(/^(\d+(?:\.\d+)?)[:=](\d+(?:\.\d+)?)%?$/);
        return m ? { min: +m[1], pct: +m[2] } : null;
      })
      .filter(function (t) {
        return t && t.min > 0;
      })
      .sort(function (a, b) {
        return a.min - b.min;
      })
      .map(function (t, i) {
        var min = Math.round(t.min * 100),
          pct = +t.pct || 0,
          reward = pct ? pct + "% off" : "Free shipping";
        return {
          min: min,
          pct: pct,
          amount: "\u20b9" + grp0(t.min),
          reward: reward,
          short: pct ? pct + "% off" : "free shipping",
          celebrate: pct
            ? pct + "% off unlocked" + (i === 1 ? ", plus free shipping." : ".")
            : "Free shipping unlocked.",
        };
      });
    EXCLUDE = String(cfg.exclude || "")
      .split(",")
      .map(function (w) {
        return w.trim().toLowerCase();
      })
      .filter(Boolean);
    REGIONS = (cfg.regions || []).map(function (r, i) {
      return { k: "r" + i, name: r.name, desc: r.desc, x: +r.x || 0, y: +r.y || 0 };
    });
    EDU = cfg.edu || [];
    REVIEWS = cfg.reviews || [];
    FAQS = cfg.faqs || [];
    KIRANA = lines(TXT.compare_a);
    IKAICOL = lines(TXT.compare_b);
    TRUST = lines(TXT.trust);
    BOXES = (cfg.boxes || []).map(function (b, i) {
      var q = {};
      lines(b.qty).forEach(function (l) {
        var m = l.match(/^(.+?)\s*[:=x\u00d7]\s*(\d+)\s*$/i);
        m && (q[m[1].trim()] = +m[2]);
      });
      b.key = "b" + i;
      b.wide = !!b.badge;
      b.items = (b.handles || []).map(function (h) {
        return [h, q[h] || 1];
      });
      return b;
    });
  }
  var BOX_ICONS = {
    one: '<circle cx="20" cy="12" r="6"/><path d="M8 34c0-7 5.4-12 12-12s12 5 12 12"/>',
    two: '<circle cx="13" cy="13" r="5"/><circle cx="27" cy="13" r="5"/><path d="M3 33c0-6 4.5-10.5 10-10.5S23 27 23 33"/><path d="M17 33c0-6 4.5-10.5 10-10.5S37 27 37 33"/>',
    four: '<circle cx="11" cy="15" r="4.5"/><circle cx="20" cy="11" r="5"/><circle cx="29" cy="15" r="4.5"/><path d="M2 33c0-5 4-9 9-9 2.4 0 4.6.9 6.2 2.5"/><path d="M38 33c0-5-4-9-9-9-2.4 0-4.6.9-6.2 2.5"/><path d="M11 34c0-5.5 4-9.5 9-9.5s9 4 9 9.5"/>',
    six: '<circle cx="8" cy="17" r="3.8"/><circle cx="16" cy="12" r="4.2"/><circle cx="24" cy="12" r="4.2"/><circle cx="32" cy="17" r="3.8"/><path d="M1 33c0-4.3 3.2-7.6 7.2-7.6"/><path d="M39 33c0-4.3-3.2-7.6-7.2-7.6"/><path d="M7 34c0-5.5 4-9.5 9-9.5 1.5 0 2.8.3 4 .9 1.2-.6 2.5-.9 4-.9 5 0 9 4 9 9.5"/>',
    own: '<circle cx="20" cy="20" r="5.5"/><path d="M20 4v5M20 31v5M4 20h5M31 20h5M8.7 8.7l3.5 3.5M27.8 27.8l3.5 3.5M8.7 31.3l3.5-3.5M27.8 12.2l3.5-3.5"/>',
  };
  function boxIcon(k) {
    return (
      '<span class="ik-ic" aria-hidden="true"><svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
      (BOX_ICONS[k] || BOX_ICONS.one) +
      "</svg></span>"
    );
  }
  var BEN_ICONS = [
    '<path d="M4 10h16l-1.6 9.2a1 1 0 0 1-1 .8H6.6a1 1 0 0 1-1-.8z"/><path d="M8 10l4-6 4 6"/>',
    '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="7.5" r="1.3"/>',
    '<path d="M5 19c0-8 6-14 15-14 0 9-6 15-14 15"/><path d="M5 19l7-7"/>',
    '<path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>',
  ];
  function grp(n) {
    var s = String(Math.round(Math.abs(n)));
    return (
      s.length > 3 &&
        (s =
          s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
          "," +
          s.slice(-3)),
      s
    );
  }
  function inr(p) {
    return "\u20B9" + grp(p / 100);
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      }[m];
    });
  }
  function cat(k) {
    return CATS.filter(function (c) {
      return c.k === k;
    })[0];
  }
  function catName(k) {
    var c = cat(k);
    return c ? c.n : k;
  }
  function shortName(n) {
    return n.replace(/^(Organic|Natural|Ikai Natural)\s+/i, "");
  }
  function start(root) {
    if (root.dataset.ready) return;
    var src = document.getElementById(root.getAttribute("data-config") || "");
    if (!src) return;
    var cfg;
    try {
      cfg = JSON.parse(src.textContent);
    } catch (e) {
      window.console && console.warn("[IKAI ration] bad config", e);
      return;
    }
    root.dataset.ready = "1";
    setup(cfg);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    build(
      root,
      base,
      (cfg.categories || []).map(function (c) {
        return { j: { c: c.k }, list: c.products || [] };
      }),
    );
  }
  function build(root, base, res) {
    var P,
      byId,
      byH,
      LIVE,
      CORE_LIVE,
      NAV,
      CICON,
      CIMG,
      ICON_ALL,
      ICON_POP,
      PRESETS,
      popular,
      origins,
      rN,
      rS;
    function prep(res2) {
      var seen = {};
      P = [];
      res2.forEach(function (r) {
        r.list.forEach(function (p) {
          if (!p || seen[p.id] || !p.v || !p.available) return;
          var tl = (p.title + " " + (p.type || "")).toLowerCase();
          if (
            EXCLUDE.some(function (w) {
              return tl.indexOf(w) >= 0;
            })
          )
            return;
          seen[p.id] = 1;
          var tags = p.tags || [];
          typeof tags == "string" &&
            (tags = tags.split(",").map(function (t) {
              return t.trim();
            }));
          for (
            var pt = String(p.type || "")
                .split(/[,>]/)
                .map(function (t) {
                  return t.trim();
                }),
              all = tags.concat(pt),
              o = "India",
              i = 0;
            i < ORIG.length;
            i++
          )
            if (all.indexOf(ORIG[i]) >= 0) {
              o = ORIG[i];
              break;
            }
          var parts = String(p.title)
              .split("|")
              .map(function (s) {
                return s.trim();
              })
              .filter(Boolean),
            size = "",
            last = parts[parts.length - 1] || "";
          parts.length > 1 &&
            /\d\s*(g|gm|kg|ml|l|ltr)\b/i.test(last) &&
            ((size = last.replace(/\s*gm$/i, "g").replace(/\s+/g, "")),
            parts.pop());
          var c = r.j.c;
          c === "oils" && /ghee/i.test(p.title) && (c = "ghee");
          var rv = p.rv && p.rv[0] ? p.rv : REV[p.handle] || [0, 0];
          P.push({
            id: p.id,
            h: p.handle,
            u: base + "products/" + p.handle,
            v: p.v,
            price: +p.price || 0,
            a: !0,
            img: p.img || "",
            o: o,
            c: c,
            n: parts[0],
            sub: parts.slice(1, 3).join(" \xB7 "),
            size: size,
            rc: +rv[0] || 0,
            r: +rv[1] || 0,
            order: P.length,
          });
        });
      });
      (void 0,
        (byId = {}),
        (byH = {}),
        P.forEach(function (p) {
          ((byId[p.id] = p), (byH[p.h] = p));
        }),
        (LIVE = CATS.filter(function (c) {
          return P.some(function (p) {
            return p.c === c.k;
          });
        })),
        (CORE_LIVE = CORE.filter(function (k) {
          return LIVE.some(function (c) {
            return c.k === k;
          });
        })),
        (NAV = [
          { k: "all", n: "All", abbr: "ALL", tile: "#E4EFE0", ink: "#2C7A3E" },
          {
            k: "popular",
            n: "Popular",
            abbr: "\u2605",
            tile: "#FBEFD6",
            ink: "#B07A12",
          },
        ].concat(LIVE)),
        (CICON = CICONS),
        (CIMG = {}),
        LIVE.forEach(function (c) {
          var p =
            P.filter(function (x) {
              return x.c === c.k && x.a && x.img;
            }).sort(function (a, b) {
              return b.rc - a.rc || a.order - b.order;
            })[0] ||
            P.filter(function (x) {
              return x.c === c.k && x.img;
            })[0];
          p && (CIMG[c.k] = p.img);
        }),
        (ICON_ALL =
          '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><rect x="3" y="3" width="7.5" height="7.5" rx="2" fill="#2C7A3E"/><rect x="13.5" y="3" width="7.5" height="7.5" rx="2" fill="#2C7A3E" opacity=".55"/><rect x="3" y="13.5" width="7.5" height="7.5" rx="2" fill="#2C7A3E" opacity=".55"/><rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" fill="#2C7A3E"/></svg>'),
        (ICON_POP =
          '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M12 2.8l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 16.8l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z" fill="#C8891F"/></svg>'));
      function preset(list) {
        var b = {};
        return (
          list.forEach(function (r) {
            var p = byH[r[0]];
            p && p.a && (b[p.id] = r[1]);
          }),
          b
        );
      }
      ((PRESETS = (function () {
        var o = {};
        BOXES.forEach(function (bx) {
          o[bx.key] = preset(bx.items);
        });
        return o;
      })()),
        (popular = P.filter(function (p) {
          return p.a;
        })
          .sort(function (a, b) {
            return b.rc * (b.r || 4) - a.rc * (a.r || 4) || a.order - b.order;
          })
          .slice(0, 18)
          .map(function (p) {
            return p.id;
          })),
        (origins = []),
        P.forEach(function (p) {
          origins.indexOf(p.o) < 0 && p.o !== "India" && origins.push(p.o);
        }),
        origins.sort(),
        (rN = 0),
        (rS = 0),
        P.forEach(function (p) {
          p.rc && p.r && ((rN += p.rc), (rS += p.r * p.rc));
        }));
    }
    prep(res);
    var RESUME = null,
      S = {
        box: {},
        cat: "all",
        q: "",
        sort: "popular",
        origin: "",
        inStock: !1,
        under150: !1,
        banner: null,
        sheet: !1,
        faq: 0,
        pin: REGIONS.length ? REGIONS[0].k : "",
      },
      $ = function (s) {
        return root.querySelector(s);
      };
    function track(name, params) {
      ((params = params || {}), (params.currency = "INR"));
      try {
        ((window.dataLayer = window.dataLayer || []),
          window.dataLayer.push(
            Object.assign({ event: "mkr_" + name }, params),
          ));
      } catch (e) {}
      try {
        typeof window.gtag == "function" &&
          window.gtag(
            "event",
            name === "place_order" ? "add_to_cart" : "mkr_" + name,
            params,
          );
      } catch (e) {}
      try {
        typeof window.fbq == "function" &&
          (name === "place_order"
            ? window.fbq("track", "AddToCart", {
                value: params.value || 0,
                currency: "INR",
                content_type: "product",
                content_ids: params.content_ids || [],
              })
            : window.fbq(
                "trackCustom",
                "MKR" +
                  name.replace(/(^|_)(\w)/g, function (m, a, b) {
                    return b.toUpperCase();
                  }),
                params,
              ));
      } catch (e) {}
    }
    function boxIds() {
      return Object.keys(S.box).map(function (id) {
        return byId[id] ? byId[id].h : id;
      });
    }
    var SKEY = "mkr_box_v1";
    function saveBox() {
      try {
        Object.keys(S.box).length
          ? localStorage.setItem(
              SKEY,
              JSON.stringify({ t: Date.now(), b: S.box }),
            )
          : localStorage.removeItem(SKEY);
      } catch (e) {}
    }
    function savedBox() {
      try {
        var raw = localStorage.getItem(SKEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || !d.b || Date.now() - d.t > 30 * 864e5) return null;
        var b = {},
          n = 0;
        return (
          Object.keys(d.b).forEach(function (id) {
            byId[id] && byId[id].a && ((b[id] = d.b[id]), n++);
          }),
          n ? b : null
        );
      } catch (e) {
        return null;
      }
    }
    root.innerHTML =
      '<div class="k-out"><div class="k-app"><div class="k-srch"><label><span aria-hidden="true">\u2315</span><input type="search" data-q placeholder="' + esc(TXT.search || "Search atta, dal, ghee, masala\u2026") + '" aria-label="Search all products"><button type="button" data-a="qx" aria-label="Clear search" hidden>\xD7</button></label></div><div data-top></div><div class="k-railbox"><div class="k-rail" data-rail></div><div class="k-filters" data-filters></div></div><section class="k-grid-wrap"><div class="k-gh"><h3 data-gt></h3><span data-gc></span></div><div class="k-grid" data-grid></div><div data-empty></div><div data-next></div><div style="height:16px"></div></section><div data-lower></div></div></div><div data-bars></div><div data-sheetwrap></div><div class="k-toast-wrap" data-toast hidden><div></div></div>';
    function gross(b) {
      var g = 0;
      return (
        Object.keys(b).forEach(function (id) {
          var p = byId[id];
          p && (g += p.price * b[id]);
        }),
        g
      );
    }
    function tierFor(g) {
      var t = null;
      return (
        TIERS.forEach(function (x) {
          g >= x.min && (t = x);
        }),
        t
      );
    }
    function count() {
      return Object.keys(S.box).reduce(function (a, k) {
        return a + S.box[k];
      }, 0);
    }
    var tT;
    function toast(m) {
      var t = $("[data-toast]");
      ((t.firstChild.textContent = m),
        (t.hidden = !1),
        (t.firstChild.style.animation = "none"),
        t.offsetWidth,
        (t.firstChild.style.animation = ""),
        clearTimeout(tT),
        (tT = setTimeout(function () {
          t.hidden = !0;
        }, 1900)));
    }
    function setBox(b, quiet) {
      var bt = tierFor(gross(S.box)),
        at = tierFor(gross(b));
      S.box = b;
      var up = at && (!bt || at.min > bt.min);
      return (
        up &&
          !quiet &&
          (toast(at.celebrate),
          track("tier_unlocked", { tier: at.reward, value: gross(b) / 100 })),
        render(),
        saveBox(),
        up
      );
    }
    function setQty(id, q) {
      var b = Object.assign({}, S.box);
      return (q <= 0 ? delete b[id] : (b[id] = Math.min(q, 20)), setBox(b));
    }
    function headerH() {
      var h = document.querySelector(
        "header-component, sticky-header, #shopify-section-header, .header-wrapper, header",
      );
      if (!h) return 0;
      var r = h.getBoundingClientRect(),
        cs = getComputedStyle(h),
        stuck =
          /sticky|fixed/.test(cs.position) ||
          (h.parentElement &&
            /sticky|fixed/.test(getComputedStyle(h.parentElement).position));
      return stuck && r.bottom > 0 ? Math.round(r.bottom) : 0;
    }
    function syncTop() {
      root.style.setProperty("--k-top", headerH() + "px");
      var a = $(".k-srch");
      a && root.style.setProperty("--k-sh", a.offsetHeight + "px");
    }
    (window.addEventListener("scroll", syncTop, { passive: !0 }),
      window.addEventListener("resize", syncTop));
    function stickyH() {
      var a = $(".k-srch"),
        b = $(".k-railbox");
      return headerH() + (a ? a.offsetHeight : 0) + (b ? b.offsetHeight : 0);
    }
    function scrollTo(el, extra) {
      if (el) {
        var y =
          el.getBoundingClientRect().top +
          window.pageYOffset -
          (extra == null ? headerH() : extra) -
          2;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
    function centre() {
      var r = $("[data-rail]"),
        b = r && r.querySelector('[aria-pressed="true"]');
      b &&
        r.scrollTo({
          left: b.offsetLeft - (r.clientWidth - b.offsetWidth) / 2,
          behavior: "smooth",
        });
    }
    function card(p) {
      var q = S.box[p.id] || 0,
        inBox = q > 0 && p.a,
        c = cat(p.c) || CATS[0],
        ctl = p.a
          ? q === 0
            ? '<button type="button" class="k-add" data-add="' +
              p.id +
              '" aria-label="Add ' +
              esc(p.n) +
              '">ADD</button>'
            : '<div class="k-step"><button type="button" data-dec="' +
              p.id +
              '" aria-label="Decrease quantity">\u2212</button><span aria-live="polite">' +
              q +
              '</span><button type="button" data-inc="' +
              p.id +
              '" aria-label="Increase quantity">+</button></div>'
          : '<div class="k-so">Sold out</div>';
      return (
        '<div class="k-card' +
        (inBox ? " in" : "") +
        (p.a ? "" : " is-sold") +
        '"><div class="k-ph"><a class="k-img" href="' +
        esc(p.u) +
        '" style="background:' +
        c.tile +
        '" tabindex="-1" aria-hidden="true">' +
        (p.img
          ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">'
          : '<span style="color:' +
            c.ink +
            '">' +
            esc(p.n.slice(0, 2)) +
            "</span>") +
        (p.a ? "" : '<span class="k-sold">Sold out</span>') +
        "</a>" +
        ctl +
        '</div><span class="k-price">' +
        inr(p.price) +
        '</span><a class="k-nm" href="' +
        esc(p.u) +
        '">' +
        esc(p.n.replace(/^(Organic|Natural|Ikai Natural)\s+/i, "")) +
        "</a>" +
        (p.sub ? '<div class="k-tag">' + esc(p.sub) + "</div>" : "") +
        '<div class="k-wt">' +
        (p.size ? "1 pack (" + esc(p.size) + ")" : "1 pack") +
        " \xB7 " +
        esc(p.o || "India") +
        "</div>" +
        (p.rc
          ? '<div class="k-rc"><b>\u2605</b> ' +
            (p.r ? p.r.toFixed(1) + " \xB7 " : "") +
            p.rc +
            (p.rc === 1 ? " review" : " reviews") +
            "</div>"
          : "") +
        "</div>"
      );
    }
    function compCard(p) {
      var c = cat(p.c) || CATS[0];
      return (
        '<div class="k-comp"><div class="k-ph"><div class="k-img" style="background:' +
        c.tile +
        '">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : "") +
        '<span class="k-cl">' +
        esc(catName(p.c)) +
        '</span></div><button type="button" class="k-add2" data-add="' +
        p.id +
        '">ADD</button></div><span class="k-price">' +
        inr(p.price) +
        '</span><div class="k-nm">' +
        esc(p.n) +
        '</div><div class="k-sub">' +
        (p.size ? "1 pack (" + esc(p.size) + ") \xB7 " : "") +
        esc(p.o) +
        "</div></div>"
      );
    }
    function segs(g, dark) {
      return TIERS.map(function (t, i) {
        var prev = i === 0 ? 0 : TIERS[i - 1].min,
          w = Math.max(0, Math.min(1, (g - prev) / (t.min - prev))),
          done = g >= t.min;
        return (
          '<div class="k-seg' +
          (done ? " done" : "") +
          (dark ? " dk" : "") +
          '"><div class="k-tr"><div style="width:' +
          Math.round(w * 100) +
          "%;background:" +
          (done ? "#2C7A3E" : "#C8891F") +
          '"></div></div><b>' +
          t.amount +
          "</b><small>" +
          t.reward +
          "</small></div>"
        );
      }).join("");
    }
    function nudge(g, short) {
      var n = TIERS.filter(function (t2) {
        return g < t2.min;
      })[0];
      if (!g)
        return short
          ? inr(FS()) + " to free shipping"
          : "Add " + inr(FS()) + " to unlock free shipping.";
      if (!n) {
        var t = tierFor(g);
        return short
          ? "all rewards unlocked"
          : "Every reward unlocked. You are saving " +
              inr(Math.round((g * t.pct) / 100)) +
              ".";
      }
      return short
        ? inr(n.min - g) + " to " + n.short
        : "Add " +
            inr(n.min - g) +
            " more to unlock " +
            n.reward.toLowerCase() +
            ".";
    }
    function renderTop(searching) {
      if (searching) {
        $("[data-top]").innerHTML = "";
        return;
      }
      var ben = (HERO.benefits || [])
          .map(function (b, i) {
            return b
              ? '<li><i><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
                  BEN_ICONS[i % BEN_ICONS.length] +
                  "</svg></i>" +
                  esc(b) +
                  "</li>"
              : "";
          })
          .join(""),
        badge =
          HERO.badge_big
            ? '<div class="ik-badge" aria-hidden="true"><small>' +
              esc(HERO.badge_top || "") +
              "</small><b>" +
              esc(HERO.badge_big) +
              "</b><small>" +
              esc(HERO.badge_bottom || "") +
              "</small></div>"
            : "",
        hero =
          '<section class="k-hero"><div>' +
          (HERO.eyebrow ? '<div class="ik-eb">' + esc(HERO.eyebrow) + "</div>" : "") +
          "<h1>" +
          esc(HERO.heading || "") +
          "</h1>" +
          (HERO.text ? "<p>" + esc(HERO.text) + "</p>" : "") +
          (ben ? '<ul class="ik-ben">' + ben + "</ul>" : "") +
          (rN >= 10
            ? '<div class="k-rt"><span aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span><strong>' +
              (rS / rN).toFixed(1) +
              "</strong><span>from " +
              rN +
              " IKAI product reviews</span></div>"
            : "") +
          "</div>" +
          badge +
          "</section>";
      function preTile(b) {
        var pr = PRESETS[b.key] || {},
          g = gross(pr),
          t = tierFor(g),
          items = Object.keys(pr).length;
        return items
          ? '<button type="button" class="k-pre' +
              (b.wide ? " wide" : "") +
              (b.popular ? " rec ik-pop" : "") +
              '" data-pre="' +
              b.key +
              '"><div class="ik-top">' +
              boxIcon(b.icon) +
              '<div class="ik-hd"><div class="t">' +
              esc(b.title) +
              (b.badge ? " <em>" + esc(b.badge) + "</em>" : "") +
              '</div><div class="s">' +
              items +
              " items \xB7 " +
              inr(g) +
              (b.sub ? " \xB7 " + esc(b.sub) : "") +
              "</div></div></div>" +
              (b.note ? '<div class="ik-note">' + esc(b.note) + "</div>" : "") +
              (t && t.pct
                ? '<div class="v">saves ' +
                  inr(Math.round((g * t.pct) / 100)) +
                  "</div>"
                : "") +
              '<span class="ik-gap"></span><span class="ik-cta">' +
              esc(TXT.box_cta || "Choose This Box") +
              "</span>" +
              (b.popular && TXT.popular_label
                ? '<span class="ik-tag">' + esc(TXT.popular_label) + "</span>"
                : "") +
              "</button>"
          : "";
      }
      var pre =
          '<section class="k-start" data-start><div class="ik-panel"><div class="k-h2n"><span>1</span><h2>' +
          esc(TXT.start_heading || "How many people eat at home?") +
          "</h2></div>" +
          (TXT.start_sub ? '<p class="ik-sub">' + esc(TXT.start_sub) + "</p>" : "") +
          '<div class="k-presets">' +
          BOXES.map(preTile).join("") +
          (TXT.own_title
            ? '<button type="button" class="k-pre" data-pre="0"><div class="ik-top">' +
              boxIcon("own") +
              '<div class="ik-hd"><div class="t">' +
              esc(TXT.own_title) +
              '</div><div class="s">' +
              esc(TXT.own_sub || "Custom items") +
              "</div></div></div>" +
              (TXT.own_note ? '<div class="ik-note">' + esc(TXT.own_note) + "</div>" : "") +
              '<span class="ik-gap"></span><span class="ik-cta">' +
              esc(TXT.own_cta || "Create Custom Box") +
              "</span></button>"
            : "") +
          "</div></div></section>",
        ban = RESUME
          ? '<div class="k-ban-w"><div class="k-ban resume"><span class="ck">\u21ba</span><span class="tx">You have a box from last time \xB7 ' +
            Object.keys(RESUME).length +
            " items \xB7 " +
            inr(gross(RESUME)) +
            '</span><button type="button" class="go" data-a="resume">Continue</button><button type="button" data-a="resume-x" aria-label="Start fresh">\xD7</button></div></div>'
          : S.banner
            ? '<div class="k-ban-w"><div class="k-ban"><span class="ck">\u2713</span><span class="tx">' +
              esc(S.banner) +
              '</span><button type="button" data-a="banx" aria-label="Dismiss">\xD7</button></div></div>'
            : "";
      $("[data-top]").innerHTML = hero + pre + ban;
    }
    function renderLower(searching, g, n) {
      if (searching) {
        $("[data-lower]").innerHTML = "";
        return;
      }
      var covered = {};
      Object.keys(S.box).forEach(function (id) {
        var p = byId[id];
        p && (covered[p.c] = 1);
      });
      var missing = CORE_LIVE.filter(function (k) {
          return !covered[k];
        }),
        h = "";
      (n &&
        missing.length &&
        (h +=
          '<section class="k-sec k-bt"><div class="k-pad"><h2>' + esc(TXT.complete_heading || "Complete your box") + '</h2><div class="k-lead">' +
          (CORE_LIVE.length - missing.length) +
          " of " +
          CORE_LIVE.length +
          " categories covered. Missing: " +
          missing.map(catName).join(", ") +
          '</div></div><div class="k-hs">' +
          missing
            .map(function (k) {
              var p = P.filter(function (x) {
                return x.c === k && x.a;
              }).sort(function (a, b) {
                return b.rc - a.rc || a.order - b.order;
              })[0];
              return p ? compCard(p) : "";
            })
            .join("") +
          "</div></section>"),
        (h +=
          '<section class="k-pad k-sec2"><div class="k-lad"><div class="t">' + esc(TXT.ladder_title || "") + '</div><div class="d">' + esc(TXT.ladder_text || "") + '</div><div class="k-segs">' +
          segs(g, !0) +
          '</div><div class="nd">' +
          nudge(g) +
          "</div></div></section>"),
        (h +=
          '<div class="k-hs k-trust">' +
          TRUST.map(function (t) {
            return "<span><i></i>" + esc(t) + "</span>";
          }).join("") +
          "</div>"),
        (h +=
          '<section class="k-sec"><div class="k-pad"><h2>' + esc(TXT.edu_heading || "") + '</h2></div><div class="k-hs">' +
          EDU.map(function (e) {
            return (
              '<div class="k-edu"><span>' +
              esc(e.tag) +
              '</span><div class="t">' +
              esc(e.t) +
              '</div><div class="d">' +
              esc(e.d) +
              "</div></div>"
            );
          }).join("") +
          "</div></section>"),
        (h +=
          '<section class="k-sec k-pad"><h2 style="margin-bottom:3px">' + esc(TXT.map_heading || "") + '</h2><div class="k-lead" style="margin:0 0 11px">' + esc(TXT.map_lead || "") + '</div><div class="k-mapwrap"><div class="k-map"><svg viewBox="0 0 400 470" role="img" aria-label="Map of India with sourcing regions"><path d="M150 40 C182 46 214 54 250 70 C266 78 276 88 288 94 C304 88 320 84 334 90 C348 96 358 104 356 112 C354 122 342 128 336 136 C326 142 310 140 300 140 C290 138 280 132 274 130 C270 144 268 154 270 166 C262 180 254 190 250 202 C254 216 258 226 256 238 C250 254 244 262 240 276 C232 300 226 320 216 342 C210 366 206 386 200 402 C192 384 186 362 180 342 C172 320 164 302 160 290 C154 272 150 260 150 250 C142 238 128 226 110 216 C98 210 86 206 80 200 C74 188 70 174 70 160 C74 144 84 130 96 120 C104 106 112 92 120 80 C130 66 140 52 150 40 Z" fill="#EAF2E6" stroke="#1B5227" stroke-width="2.4" stroke-linejoin="round"/>' +
          REGIONS.map(function (r) {
            var on = S.pin === r.k;
            return (
              '<g data-pin="' +
              r.k +
              '" style="cursor:pointer"><circle cx="' +
              r.x +
              '" cy="' +
              r.y +
              '" r="' +
              (on ? 11 : 7) +
              '" fill="' +
              (on ? "#C8891F" : "#1B5227") +
              '" stroke="#FFFFFF" stroke-width="2"/><circle cx="' +
              r.x +
              '" cy="' +
              r.y +
              '" r="18" fill="transparent"/></g>'
            );
          }).join("") +
          '</svg></div><div class="k-hs k-regs" data-regs>' +
          REGIONS.map(function (r) {
            var on = S.pin === r.k;
            return (
              '<button type="button" class="k-reg' +
              (on ? " on" : "") +
              '" data-pin="' +
              r.k +
              '"><div><i></i><b>' +
              esc(r.name) +
              "</b></div><p>" +
              esc(r.desc) +
              "</p></button>"
            );
          }).join("") +
          "</div></div></section>"),
        (h +=
          '<section class="k-sec k-pad"><h2 style="margin-bottom:11px">' + esc(TXT.compare_heading || "") + '</h2><div class="k-vs"><div class="a"><div class="h">' + esc(TXT.compare_a_title || "") + '</div>' +
          KIRANA.map(function (k) {
            return (
              '<div class="r"><span>\u2014</span><span>' + esc(k) + "</span></div>"
            );
          }).join("") +
          '</div><div class="b"><div class="h">' + esc(TXT.compare_b_title || "") + '</div>' +
          IKAICOL.map(function (k) {
            return (
              '<div class="r"><span>\u2192</span><span>' + esc(k) + "</span></div>"
            );
          }).join("") +
          "</div></div></section>"),
        (h +=
          '<section class="k-sec ik-revsec"><div class="k-pad"><h2>' + esc(TXT.reviews_heading || "") + '</h2></div><div class="k-hs">' +
          REVIEWS.map(function (r) {
            return (
              '<figure class="k-rev"><div class="st" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</div><blockquote>' +
              esc(r.q) +
              '</blockquote><figcaption><span class="i">' +
              esc(r.i) +
              "</span><span>" +
              esc(r.a) +
              "</span></figcaption></figure>"
            );
          }).join("") +
          "</div></section>"),
        (h +=
          '<section class="k-sec k-pad"><h2 style="margin-bottom:10px">' + esc(TXT.faq_heading || "") + '</h2><div class="k-faqs">' +
          FAQS.map(function (f, i) {
            var o = S.faq === i;
            return (
              '<div class="k-faq"><button type="button" data-faq="' +
              i +
              '" aria-expanded="' +
              o +
              '"><span>' +
              esc(f.q) +
              '</span><span class="pl" style="transform:' +
              (o ? "rotate(45deg)" : "none") +
              '">+</span></button>' +
              (o ? '<div class="an">' + esc(f.a) + "</div>" : "") +
              "</div>"
            );
          }).join("") +
          "</div></section>"),
        (h +=
          '<section class="k-pad" style="padding-top:20px;padding-bottom:20px"><div class="k-cta"><div><h2>' + esc(TXT.cta_heading || "") + "</h2><p>" + esc(TXT.cta_text || "") + '</p><button type="button" data-a="gostart">' + esc(TXT.cta_button || "Build My Box") + "</button></div></div></section>"),
        ($("[data-lower]").innerHTML = h));
    }
    function render() {
      var q = S.q.trim().toLowerCase(),
        searching = q.length > 0,
        g = gross(S.box),
        t = tierFor(g),
        pct = t ? t.pct : 0,
        disc = Math.round((g * pct) / 100 / 100) * 100,
        ship = 0,
        total = g - disc,
        n = count();
      renderTop(searching);
      var counts = {};
      (Object.keys(S.box).forEach(function (id) {
        var p = byId[id];
        p && (counts[p.c] = (counts[p.c] || 0) + S.box[id]);
      }),
        ($("[data-rail]").innerHTML = NAV.map(function (c) {
          var on = S.cat === c.k && !searching,
            ic = CICON[c.k],
            icon = ic
              ? '<span class="im"><img src="' +
                ic +
                '" alt="" loading="lazy" width="96" height="96"></span>'
              : c.k === "all"
                ? ICON_ALL
                : c.k === "popular"
                  ? ICON_POP
                  : CIMG[c.k]
                    ? '<img src="' + esc(CIMG[c.k]) + '" alt="" loading="lazy">'
                    : '<span style="color:' + c.ink + '">' + c.abbr + "</span>",
            cnt = c.k === "all" ? n : counts[c.k];
          return (
            '<button type="button" class="k-cat' +
            (on ? " on" : "") +
            (ic ? " ic" : "") +
            '" data-cat="' +
            c.k +
            '" aria-pressed="' +
            on +
            '"><span class="tl" style="background:' +
            (ic ? "#FCFBF7" : c.tile) +
            '">' +
            icon +
            (cnt && c.k !== "all" ? "<em>" + cnt + "</em>" : "") +
            '</span><span class="lb">' +
            esc(c.n) +
            "</span></button>"
          );
        }).join("")),
        ($("[data-filters]").innerHTML =
          '<div class="k-sel"><select data-sort aria-label="Sort products"><option value="popular"' +
          (S.sort === "popular" ? " selected" : "") +
          '>Sort: Popular</option><option value="low"' +
          (S.sort === "low" ? " selected" : "") +
          '>Price: low to high</option><option value="high"' +
          (S.sort === "high" ? " selected" : "") +
          '>Price: high to low</option><option value="reviewed"' +
          (S.sort === "reviewed" ? " selected" : "") +
          '>Most reviewed</option></select><span>\u25BC</span></div><div class="k-sel' +
          (S.origin ? " on" : "") +
          '"><select data-origin aria-label="Filter by origin"><option value="">All origins</option>' +
          origins
            .map(function (o) {
              return (
                "<option" +
                (S.origin === o ? " selected" : "") +
                ">" +
                esc(o) +
                "</option>"
              );
            })
            .join("") +
          '</select><span>\u25BC</span></div><button type="button" class="k-chip' +
          (S.under150 ? " on" : "") +
          '" data-a="u150" aria-pressed="' +
          S.under150 +
          '">Under \u20B9150</button>'));
      var list, title;
      (searching
        ? ((list = P.filter(function (p) {
            return (
              (p.n + " " + p.sub + " " + p.o + " " + catName(p.c))
                .toLowerCase()
                .indexOf(q) >= 0
            );
          })),
          (title = "Results for \u201C" + S.q.trim() + "\u201D"))
        : S.cat === "all"
          ? ((list = P.slice()), (title = "All products"))
          : S.cat === "popular"
            ? ((list = popular.map(function (id) {
                return byId[id];
              })),
              (title = "Popular this month"))
            : ((list = P.filter(function (p) {
                return p.c === S.cat;
              })),
              (title = catName(S.cat))),
        S.origin &&
          (list = list.filter(function (p) {
            return p.o === S.origin;
          })),
        S.inStock &&
          (list = list.filter(function (p) {
            return p.a;
          })),
        S.under150 &&
          (list = list.filter(function (p) {
            return p.price <= 15e3;
          })),
        (list = list.slice()),
        S.sort === "low"
          ? list.sort(function (a, b) {
              return a.price - b.price;
            })
          : S.sort === "high"
            ? list.sort(function (a, b) {
                return b.price - a.price;
              })
            : S.sort === "reviewed"
              ? list.sort(function (a, b) {
                  return b.rc - a.rc;
                })
              : S.cat !== "popular" &&
                list.sort(function (a, b) {
                  return b.a - a.a || a.order - b.order;
                }),
        ($("[data-gt]").textContent = title),
        ($("[data-gc]").textContent =
          list.length + (list.length === 1 ? " item" : " items")),
        ($("[data-grid]").innerHTML = list.map(card).join("")),
        ($("[data-empty]").innerHTML = list.length
          ? ""
          : '<div class="k-empty">Nothing matches those filters.<br><button type="button" data-a="reset">Clear filters</button></div>'));
      var ni = NAV.map(function (c) {
          return c.k;
        }).indexOf(S.cat),
        nx = !searching && ni >= 0 && ni < NAV.length - 1 ? NAV[ni + 1] : null;
      (($("[data-next]").innerHTML = nx
        ? '<button type="button" class="k-next" data-cat="' +
          nx.k +
          '" data-scroll="1">Next: ' +
          esc(nx.n) +
          ' <span aria-hidden="true">\u2192</span></button>'
        : ""),
        ($('[data-a="qx"]').hidden = !searching),
        renderLower(searching, g, n));
      var bars = "";
      if (
        (!n &&
          !S.sheet &&
          (bars =
            '<div class="k-nudgebar"><div><span class="ic">\u25F1</span><div><div class="t">Unlock free delivery</div><div class="s">Add ' +
            inr(FS()) +
            " to your box</div></div></div></div>"),
        n && !S.sheet)
      ) {
        var nx2 = TIERS.filter(function (t2) {
          return g < t2.min;
        })[0];
        bars =
          '<div class="k-bar"><div><div class="k-bp"><div class="tr"><div style="width:' +
          Math.round(Math.min(1, g / TOP()) * 100) +
          '%"></div></div></div><div class="k-bmsg">' +
          (nx2
            ? "Add <b>" +
              inr(nx2.min - g) +
              "</b> more for " +
              nx2.reward.toLowerCase()
            : "<b>" +
              (tierFor(g) ? tierFor(g).pct : 0) +
              "% off</b> applied \xB7 you save " +
              inr(disc)) +
          '</div><div class="k-br"><button type="button" class="sum" data-a="open"><span class="c">' +
          n +
          (n === 1 ? " item" : " items") +
          '</span><span class="tt"><b>' +
          inr(total) +
          "</b>" +
          (g > total ? "<s>" + inr(g) + "</s>" : "") +
          '</span></button><button type="button" class="go" data-a="order">Place order <span aria-hidden="true">\u203A</span></button></div></div></div>';
      }
      if (
        (($("[data-bars]").innerHTML = bars),
        root.style.setProperty("--k-pad", n ? "104px" : "76px"),
        root.style.setProperty("--k-toast", n ? "120px" : "92px"),
        S.sheet)
      ) {
        var lines = Object.keys(S.box)
            .map(function (id) {
              var p = byId[id],
                qq = S.box[id];
              return (
                '<div class="k-line"><div class="t"><div>' +
                esc(p.n) +
                "</div><small>" +
                esc(p.size) +
                (p.size ? " \xB7 " : "") +
                inr(p.price) +
                '</small></div><div class="k-qs"><button type="button" data-dec="' +
                id +
                '" aria-label="Decrease quantity">\u2212</button><span>' +
                qq +
                '</span><button type="button" data-inc="' +
                id +
                '" aria-label="Increase quantity">+</button></div><div class="lt">' +
                inr(p.price * qq) +
                "</div></div>"
              );
            })
            .join(""),
          cov = {};
        Object.keys(S.box).forEach(function (id) {
          cov[byId[id].c] = 1;
        });
        var miss = CORE_LIVE.filter(function (k) {
          return !cov[k];
        });
        $("[data-sheetwrap]").innerHTML =
          '<div class="k-shade" data-a="close"></div><div class="k-sheet-w"><div class="k-sheet" role="dialog" aria-modal="true" aria-label="Your box"><div class="k-sh"><button type="button" data-a="close" class="grab" aria-label="Close"><span></span></button><div><h3>Your box</h3><span>' +
          (n ? n + (n === 1 ? " item" : " items") : "empty") +
          '</span></div></div><div class="k-lb"><div class="k-segs">' +
          segs(g, !1) +
          '</div><div class="nd">' +
          nudge(g) +
          '</div></div><div class="k-lines">' +
          (lines || '<div class="k-empty">Your box is empty.</div>') +
          '</div><div class="k-tot"><div><span>Subtotal before discount</span><span>' +
          inr(g) +
          '</span></div><div class="d"><span>' +
          (pct ? "Bundle discount (" + pct + "%)" : "Bundle discount") +
          "</span><span>" +
          (disc ? "\u2212 " + inr(disc) : "\u2014") +
          "</span></div><div><span>Delivery</span><span>" +
          (g ? (g >= FS() ? "Free" : "Calculated at checkout") : "\u2014") +
          '</span></div><div class="g"><span>Total</span><b>' +
          inr(total) +
          "</b></div>" +
          (disc
            ? '<div class="sv">You save ' + inr(disc) + " on this box</div>"
            : "") +
          "</div>" +
          (n && miss.length
            ? '<div class="k-miss"><div>Add before you order:</div><div>' +
              miss
                .map(function (k) {
                  return (
                    '<button type="button" data-jump="' +
                    k +
                    '">' +
                    esc(catName(k)) +
                    "</button>"
                  );
                })
                .join("") +
              "</div></div>"
            : "") +
          '<button type="button" class="k-order" data-a="order"' +
          (n ? "" : " disabled") +
          '>Place My Order</button><div class="k-fine">Box discount applies automatically at checkout.</div><button type="button" class="k-clear" data-a="clear">Empty my box</button></div></div>';
      } else $("[data-sheetwrap]").innerHTML = "";
    }
    var busy = !1,
      liftT;
    function post(items) {
      return fetch(base + "cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        return r.text().then(function (t) {
          var j = null;
          try {
            j = JSON.parse(t);
          } catch (e) {}
          if (!r.ok || !j) {
            var err = new Error(
              (j && (j.description || j.message)) || "HTTP " + r.status,
            );
            throw ((err.status = r.status), (err.shopify = !!j), err);
          }
          return j;
        });
      });
    }
    function formFallback(items) {
      var f = document.createElement("form");
      ((f.method = "POST"),
        (f.action = base + "cart/add"),
        (f.style.display = "none"),
        items.forEach(function (it, i) {
          [
            ["items[" + i + "][id]", it.id],
            ["items[" + i + "][quantity]", it.quantity],
            ["items[" + i + "][properties][_source]", "Mahina Ka Ration"],
          ].forEach(function (p) {
            var x = document.createElement("input");
            ((x.type = "hidden"),
              (x.name = p[0]),
              (x.value = p[1]),
              f.appendChild(x));
          });
        }));
      var r = document.createElement("input");
      ((r.type = "hidden"),
        (r.name = "return_to"),
        (r.value = base + "cart"),
        f.appendChild(r),
        document.body.appendChild(f),
        f.submit());
    }
    function order() {
      if (!(busy || !count())) {
        ((busy = !0),
          root.querySelectorAll('[data-a="order"]').forEach(function (b) {
            ((b.disabled = !0), (b.textContent = "Adding to cart\u2026"));
          }));
        var items = Object.keys(S.box).map(function (id) {
          return {
            id: byId[id].v,
            quantity: S.box[id],
            properties: { _source: "Mahina Ka Ration" },
          };
        });
        track("place_order", {
          value: gross(S.box) / 100,
          items: count(),
          discount_pct: pctNow(),
          content_ids: boxIds(),
        });
        var skipped = [],
          reasons = [],
          blocked = !1;
        post(items)
          .catch(function (e) {
            if (!e.shopify) throw ((blocked = !0), e);
            return items.reduce(function (ch, it) {
              return ch.then(function () {
                return post([it]).catch(function (er) {
                  er.shopify || (blocked = !0);
                  var p = P.filter(function (x) {
                    return x.v === it.id;
                  })[0];
                  (skipped.push(p ? shortName(p.n) : "an item"),
                    er.message && reasons.push(er.message));
                });
              });
            }, Promise.resolve());
          })
          .then(function () {
            if (blocked || skipped.length === items.length)
              throw new Error("fallback");
            skipped.length
              ? (toast(
                  "Not added: " +
                    skipped.join(", ") +
                    (reasons[0] ? " (" + reasons[0] + ")" : ""),
                ),
                setTimeout(go, 2600))
              : go();
          })
          .catch(function (e) {
            (window.console &&
              console.warn(
                "[Mahina Ka Ration] quick add failed, using standard cart form",
                e && e.message,
              ),
              toast("Adding your box to the cart\u2026"),
              formFallback(
                items.filter(function (it) {
                  var p = P.filter(function (x) {
                    return x.v === it.id;
                  })[0];
                  return !p || skipped.indexOf(shortName(p.n)) < 0 || blocked;
                }),
              ));
          });
      }
    }
    function pctNow() {
      var t = tierFor(gross(S.box));
      return t ? t.pct : 0;
    }
    function go() {
      var api = window.essentialCartApi;
      try {
        localStorage.removeItem(SKEY);
      } catch (e) {}
      fetch(base + "cart.js", { credentials: "same-origin" })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          try {
            document.dispatchEvent(
              new CustomEvent("cart:update", {
                bubbles: !0,
                detail: {
                  resource: cart,
                  sourceId: "mkr",
                  data: { source: "mkr", itemCount: cart.item_count },
                },
              }),
            );
          } catch (e) {}
          try {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: !0 }),
            );
          } catch (e) {}
        })
        .catch(function () {})
        .then(function () {
          api && typeof api.openCart == "function"
            ? ((S.sheet = !1),
              (S.box = {}),
              (S.banner = null),
              (busy = !1),
              render(),
              Promise.resolve(
                typeof api.refreshCart == "function" ? api.refreshCart() : null,
              )
                .catch(function () {})
                .then(function () {
                  api.openCart();
                }))
            : (window.location.href = base + "cart");
        });
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest(
        "[data-add],[data-inc],[data-dec],[data-cat],[data-pre],[data-jump],[data-pin],[data-faq],[data-a]",
      );
      if (!(!t || !root.contains(t))) {
        var d = t.dataset;
        if (d.add) {
          var up = setQty(+d.add, 1),
            p = byId[d.add];
          (p &&
            track("add_to_box", {
              item_name: p.n,
              item_id: p.h,
              price: p.price / 100,
              value: gross(S.box) / 100,
            }),
            !up && p && toast(shortName(p.n) + " added"));
          return;
        }
        if (d.inc) {
          setQty(+d.inc, (S.box[d.inc] || 0) + 1);
          return;
        }
        if (d.dec) {
          setQty(+d.dec, (S.box[d.dec] || 0) - 1);
          return;
        }
        if (d.cat) {
          ((S.cat = d.cat),
            (S.q = ""),
            ($("[data-q]").value = ""),
            render(),
            centre());
          var gw = $(".k-grid-wrap");
          (d.scroll || gw.getBoundingClientRect().top < stickyH()) &&
            scrollTo(gw, stickyH());
          return;
        }
        if (d.pre !== void 0) {
          var bx = BOXES.filter(function (x) {
            return x.key === d.pre;
          })[0];
          if (!bx)
            ((S.banner = null),
              setBox({}, !0),
              track("preset_selected", { preset: "build_my_own", value: 0 }));
          else {
            ((S.banner = bx.title + " box is ready. Swap or remove anything below."),
              (S.cat = "all"));
            var pb = Object.assign({}, PRESETS[bx.key]);
            (setBox(pb),
              track("preset_selected", {
                preset: bx.title,
                value: gross(pb) / 100,
                items: Object.keys(pb).length,
              }));
          }
          setTimeout(function () {
            scrollTo(
              $(".k-railbox"),
              headerH() + ($(".k-srch") ? $(".k-srch").offsetHeight : 0),
            );
          }, 60);
          return;
        }
        if (d.jump) {
          ((S.sheet = !1),
            (S.cat = d.jump),
            (S.q = ""),
            (S.origin = ""),
            (S.inStock = !1),
            (S.under150 = !1),
            render(),
            centre(),
            scrollTo($(".k-grid-wrap"), stickyH()));
          return;
        }
        if (d.pin) {
          ((S.pin = d.pin), render());
          return;
        }
        if (d.faq !== void 0) {
          ((S.faq = S.faq === +d.faq ? -1 : +d.faq), render());
          return;
        }
        switch (d.a) {
          case "qx":
            ((S.q = ""), ($("[data-q]").value = ""), render());
            break;
          case "banx":
            ((S.banner = null), render());
            break;
          case "instock":
            ((S.inStock = !S.inStock), render());
            break;
          case "u150":
            ((S.under150 = !S.under150), render());
            break;
          case "reset":
            ((S.origin = ""),
              (S.inStock = !1),
              (S.under150 = !1),
              (S.sort = "popular"),
              render());
            break;
          case "gostart":
            scrollTo($("[data-start]"));
            break;
          case "open":
            ((S.sheet = !0),
              render(),
              track("view_box", {
                value: gross(S.box) / 100,
                items: count(),
                content_ids: boxIds(),
              }));
            break;
          case "close":
            ((S.sheet = !1), render());
            break;
          case "clear":
            ((S.banner = null), (S.sheet = !1), setBox({}, !0));
            break;
          case "resume":
            ((S.banner = null),
              setBox(RESUME || {}, !0),
              (RESUME = null),
              track("box_resumed", {
                value: gross(S.box) / 100,
                items: count(),
              }),
              scrollTo($(".k-railbox"), headerH()));
            break;
          case "resume-x":
            RESUME = null;
            try {
              localStorage.removeItem(SKEY);
            } catch (e2) {}
            render();
            break;
          case "order":
            order();
            break;
        }
      }
    });
    var qT;
    (root.addEventListener("input", function (e) {
      if (e.target.matches("[data-q]")) {
        clearTimeout(qT);
        var v = e.target.value;
        qT = setTimeout(function () {
          ((S.q = v), render());
        }, 120);
      }
    }),
      root.addEventListener("change", function (e) {
        (e.target.matches("[data-sort]") &&
          ((S.sort = e.target.value), render()),
          e.target.matches("[data-origin]") &&
            ((S.origin = e.target.value), render()));
      }),
      document.addEventListener("keydown", function (e) {
        e.key === "Escape" && S.sheet && ((S.sheet = !1), render());
      }));
    function measure() {
      var h = 0,
        W = innerWidth,
        H = innerHeight;
      (document.querySelectorAll("body *").forEach(function (el) {
        if (!root.contains(el)) {
          var cs = getComputedStyle(el);
          if (!(
            cs.position !== "fixed" ||
            cs.display === "none" ||
            cs.visibility === "hidden"
          )) {
            var r = el.getBoundingClientRect();
            r.width > W * 0.8 &&
              r.height > 30 &&
              r.height < 140 &&
              Math.abs(r.bottom - H) < 4 &&
              r.top > H * 0.6 &&
              (h = Math.max(h, Math.round(r.height)));
          }
        }
      }),
        root.style.setProperty("--k-bottom", h + "px"));
    }
    function lift() {
      var W = innerWidth,
        H = innerHeight,
        sheet = !!root.querySelector(".k-sheet"),
        obs = [];
      root
        .querySelectorAll(".k-bar>div,.k-nudgebar>div,.k-pill")
        .forEach(function (b) {
          var r = b.getBoundingClientRect();
          r.width &&
            r.height &&
            getComputedStyle(b).visibility !== "hidden" &&
            obs.push(r);
        });
      function rs(el) {
        el.style.transform = el.dataset.kT || "";
        el.style.visibility = el.dataset.kV || "";
        el.removeAttribute("data-k-lift");
        el.removeAttribute("data-k-dy");
        el.removeAttribute("data-k-t");
        el.removeAttribute("data-k-v");
      }
      function st(el, dy, hide) {
        if (!el.hasAttribute("data-k-lift")) {
          el.dataset.kT = el.style.transform || "";
          el.dataset.kV = el.style.visibility || "";
          el.dataset.kLift = "1";
        }
        el.dataset.kDy = dy;
        var t = (
          (el.dataset.kT || "") + (dy ? " translateY(-" + dy + "px)" : "")
        ).trim();
        el.style.transform !== t && (el.style.transform = t);
        var v = hide ? "hidden" : el.dataset.kV || "";
        el.style.visibility !== v && (el.style.visibility = v);
      }
      document.querySelectorAll("body *").forEach(function (el) {
        if (root.contains(el)) return;
        var on = el.hasAttribute("data-k-lift");
        if (
          !on &&
          el.parentElement &&
          el.parentElement.closest("[data-k-lift]")
        )
          return;
        var cs = getComputedStyle(el);
        if (cs.position !== "fixed" || cs.display === "none") {
          on && rs(el);
          return;
        }
        var dy = +(el.dataset.kDy || 0),
          r = el.getBoundingClientRect(),
          bot = r.bottom + dy;
        if (
          !r.width ||
          !r.height ||
          r.width > W * 0.8 ||
          r.height > 260 ||
          bot < H * 0.45 ||
          el.closest('[role="dialog"], dialog, [aria-modal="true"]')
        ) {
          on && rs(el);
          return;
        }
        if (sheet) {
          st(el, 0, !0);
          return;
        }
        var need = 0;
        obs.forEach(function (o) {
          r.left < o.right &&
            r.right > o.left &&
            bot > o.top - 4 &&
            (need = Math.max(need, Math.ceil(bot - o.top + 10)));
        });
        need > 0 ? st(el, need, !1) : on && rs(el);
      });
    }
    return (
      measure(),
      [600, 1500, 3e3, 6e3].forEach(function (t) {
        setTimeout(measure, t);
      }),
      addEventListener("resize", measure),
      (liftT = setInterval(function () {
        if (!root.isConnected) return clearInterval(liftT);
        lift();
      }, 600)),
      document.querySelectorAll("h1").forEach(function (h) {
        if (!root.contains(h) && /monthly ration box/i.test(h.textContent)) {
          var w = h.closest(".shopify-block") || h;
          w.style.display = "none";
        }
      }),
      (RESUME = savedBox()),
      RESUME &&
        (track("box_restored_offered", { items: Object.keys(RESUME).length }),
        render()),
      syncTop(),
      render(),
      enhance(root),
      {
        refresh: function (res2) {
          prep(res2);
          var keep = {};
          (Object.keys(S.box).forEach(function (id) {
            byId[id] && byId[id].a && (keep[id] = S.box[id]);
          }),
            (S.box = keep),
            render());
        },
      }
    );
  }
  /* ---------- IKAI enhancements: selected box, close (x) on bars, "View box" pill, slider arrows ---------- */
  var CHEV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  function enhance(root) {
    var sel = null,
      min = !1,
      nudgeOff = !1;
    function upd(sc) {
      var n = sc && sc._ikNav;
      if (!n) return;
      var over = sc.scrollWidth > sc.clientWidth + 4;
      n.classList.contains("is-off") === over && n.classList.toggle("is-off", !over);
      var a = n.querySelector(".ik-prev"),
        b = n.querySelector(".ik-next"),
        st = sc.scrollLeft <= 2,
        en = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
      a.disabled !== st && (a.disabled = st);
      b.disabled !== en && (b.disabled = en);
    }
    function arrows(sc, mount, side) {
      if (!sc || !mount) return;
      var nav = null;
      for (var i = 0; i < mount.children.length; i++)
        if (mount.children[i].classList.contains("ik-nav")) {
          nav = mount.children[i];
          break;
        }
      if (!nav) {
        nav = document.createElement("div");
        nav.className = "ik-nav" + (side ? " ik-nav-side" : "");
        nav.innerHTML =
          '<button type="button" class="ik-prev" aria-label="Previous">' +
          CHEV +
          '</button><button type="button" class="ik-next" aria-label="Next" style="transform:' +
          (side ? "translateY(-50%) " : "") +
          'scaleX(-1)">' +
          CHEV +
          "</button>";
        side ? mount.insertBefore(nav, mount.firstChild) : mount.appendChild(nav);
      }
      nav._sc = sc;
      sc._ikNav = nav;
      if (!sc._ikBound) {
        sc._ikBound = 1;
        sc.addEventListener(
          "scroll",
          function () {
            upd(sc);
          },
          { passive: !0 },
        );
      }
      upd(sc);
    }
    function sliders() {
      var rs = root.querySelector(".ik-revsec");
      rs && arrows(rs.querySelector(".k-hs"), rs.querySelector(".k-pad"));
      var st2 = root.querySelector(".k-start");
      st2 && arrows(st2.querySelector(".k-presets"), st2.querySelector(".k-h2n"));
      var rg = root.querySelector("[data-regs]");
      if (rg) {
        var rw = rg.parentElement;
        if (rw) {
          rw.classList.contains("ik-regwrap") || rw.classList.add("ik-regwrap");
          arrows(rg, rw, !0);
          var q1 = rg.getBoundingClientRect(),
            q0 = rw.getBoundingClientRect(),
            rm = Math.round(q1.top + q1.height / 2 - q0.top);
          rm > 0 && rw._ikMid !== rm && ((rw._ikMid = rm), rw.style.setProperty("--ik-reg-mid", rm + "px"));
        }
        if (!rg._ikPos) {
          rg._ikPos = 1;
          var on = rg.querySelector(".k-reg.on");
          if (on && rg.scrollWidth > rg.clientWidth + 4) {
            rg.style.scrollBehavior = "auto";
            rg.scrollLeft = Math.max(0, on.offsetLeft - rg.offsetLeft);
            rg.style.scrollBehavior = "";
            upd(rg);
          }
        }
      }
      var rb = root.querySelector(".k-railbox"),
        rl2 = root.querySelector("[data-rail]");
      if (rb && rl2) {
        arrows(rl2, rb, !0);
        var tl = rl2.querySelector(".k-cat .tl") || rl2,
          r1 = tl.getBoundingClientRect(),
          r0 = rb.getBoundingClientRect(),
          mid = Math.round(r1.top + r1.height / 2 - r0.top);
        mid > 0 && rb._ikMid !== mid && ((rb._ikMid = mid), rb.style.setProperty("--ik-rail-mid", mid + "px"));
      }
    }
    function paint() {
      if (!root.isConnected) return;
      root.querySelectorAll("[data-pre]").forEach(function (b) {
        var on = sel !== null && b.getAttribute("data-pre") === sel;
        b.classList.contains("is-on") !== on && b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      root.querySelectorAll(".k-bar>div,.k-nudgebar>div").forEach(function (box) {
        if (!box.querySelector(".k-x")) {
          var x = document.createElement("button");
          x.type = "button";
          x.className = "k-x";
          x.setAttribute("aria-label", "Close");
          x.innerHTML = "&times;";
          box.appendChild(x);
        }
      });
      root.classList.toggle("k-min", min);
      root.classList.toggle("k-nudge-off", nudgeOff);
      var presBox = root.querySelector(".k-presets");
      presBox && presBox.classList.toggle("ik-has-sel", sel !== null);
      sliders();
      var bar = root.querySelector(".k-bar"),
        pill = root.querySelector(".k-pill");
      if (!pill) {
        pill = document.createElement("button");
        pill.type = "button";
        pill.className = "k-pill";
        pill.hidden = !0;
        root.appendChild(pill);
      }
      var show = min && !!bar;
      pill.hidden === show && (pill.hidden = !show);
      if (bar) {
        var c = bar.querySelector(".k-br .c"),
          t = bar.querySelector(".k-br .tt b"),
          txt = "View box \xB7 " + (c ? c.textContent : "") + " \xB7 " + (t ? t.textContent : "");
        pill.textContent !== txt && (pill.textContent = txt);
      }
    }
    root.addEventListener(
      "click",
      function (e) {
        var t = e.target,
          ar = t.closest(".ik-nav button");
        if (ar) {
          var nv = ar.closest(".ik-nav"),
            sc = nv && nv._sc;
          if (sc) {
            e.stopPropagation();
            var amt = Math.max(sc.clientWidth * 0.8, 160),
              kc = sc.matches("[data-regs]") && sc.querySelectorAll(".k-reg");
            if (kc && kc.length > 1) {
              var stp = kc[1].offsetLeft - kc[0].offsetLeft;
              stp > 0 && (amt = stp * Math.max(1, Math.floor((sc.clientWidth + 4) / stp)));
            }
            sc.scrollBy({ left: (ar.classList.contains("ik-prev") ? -1 : 1) * amt, behavior: "smooth" });
          }
          return;
        }
        if (t.closest(".k-bar .k-x")) min = !0;
        else if (t.closest(".k-nudgebar .k-x")) nudgeOff = !0;
        else if (t.closest(".k-pill")) min = !1;
        else if (t.closest("[data-pre]")) {
          sel = t.closest("[data-pre]").getAttribute("data-pre");
          min = !1;
        } else if (t.closest('[data-a="clear"], [data-a="resume"]')) sel = null;
        else return;
        paint();
        setTimeout(paint, 0);
      },
      !0,
    );
    new MutationObserver(paint).observe(root, { childList: !0, subtree: !0 });
    addEventListener("resize", paint);
    paint();
  }
  function boot() {
    document.querySelectorAll(".mkr[data-ikai-ration]").forEach(start);
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot();
  document.addEventListener("shopify:section:load", boot);
})();
